import React from 'react';
import { useChat } from '../../../../../../hooks/api/useChat';
import ChatArea from './ChatArea';
import { AnimateLoadedContent } from '../../../../../v2BaseComponents/Loader';
import { useIsMobileLayout } from '../../../../../../hooks/useIsMobileLayout';
import Stack from '../../../../../v2BaseComponents/Stack';
import { View } from 'react-native';
import { DesktopChatList } from './ChatList';

export type ChatOwnProps = {
    medicalProfileId: string;
    defaultChatId?: string;
    defaultChatPrompt?: string;
    disableSetDefaultChat?: boolean;
};

export type ChatProps = ChatOwnProps;

const Chat: React.FC<ChatProps> = (props) => {
    const isMobile = useIsMobileLayout();
    const [selectedChatId, setSelectedChatId] = React.useState<string | null>(props.defaultChatId || null);
    const {
        chat,
        isLoadingChat,
        createChat,
        isCreatingChat,
        createChatMessage,
        isWaitingOnChatMessage,
        deleteChat,
        isDeletingChat,
        isLoadingChats,
        chats,
        isChatFailed,
    } = useChat({
        medicalProfileId: props.medicalProfileId,
        chatId: selectedChatId,
        onChatIdChange: setSelectedChatId,
        defaultChatId: !props.defaultChatPrompt && !props.disableSetDefaultChat,
    });
    return (
        <AnimateLoadedContent isLoading={isLoadingChats}>
            {() => (
                <Stack horizontal fullWidth fullHeight>
                    {isMobile ? null : (
                        <DesktopChatList
                            chats={chats || { items: [] }}
                            selectedChatId={selectedChatId}
                            onSelectChat={setSelectedChatId}
                            onDeleteChat={deleteChat}
                        />
                    )}
                    <View style={{ flex: 1, height: '100%' }}>
                        <ChatArea
                            medicalProfileId={props.medicalProfileId}
                            isLoadingChat={isLoadingChat}
                            chat={chat}
                            isWaitingOnChatMessage={isWaitingOnChatMessage}
                            isCreatingChat={isCreatingChat}
                            onCreateChat={createChat}
                            onCreateChatMessage={createChatMessage}
                            isDeletingChat={isDeletingChat}
                            onDeleteChat={() => selectedChatId && deleteChat(selectedChatId)}
                            chats={chats || { items: [] }}
                            selectedChatId={selectedChatId}
                            onSelectChat={setSelectedChatId}
                            defaultChatPrompt={props.defaultChatPrompt}
                            isChatFailed={isChatFailed}
                        />
                    </View>
                </Stack>
            )}
        </AnimateLoadedContent>
    );
};

export default React.memo(Chat);
